import { FC, ReactNode } from 'react'
import { useUserConfigurationsContext } from '@reapit-sales/api-v2'
import { UserIdentificationUtility } from './utility'

interface UserIdentityWrapperProps {
  children: ReactNode
}

interface User {
  id: string
  email: string
  username?: string
}

export const UserIdentityWrapper: FC<UserIdentityWrapperProps> = ({ children }) => {
  const { staffMember } = useUserConfigurationsContext()
  const firstName = staffMember?.firstName || ''
  const lastName = staffMember?.lastName || ''
  const username = firstName + ' ' + lastName

  const user: User = {
    id: staffMember?.id || '',
    email: staffMember?.email || '',
    username: username.trim() || '',
  }

  // Set user identity in Mixpanel and Sentry
  UserIdentificationUtility.setUserIdentity(user)

  return <>{children}</>
}
